import { render, staticRenderFns } from "./OverviewXrayPreview.vue?vue&type=template&id=6b951d2b&scoped=true"
import script from "./OverviewXrayPreview.vue?vue&type=script&lang=js"
export * from "./OverviewXrayPreview.vue?vue&type=script&lang=js"
import style0 from "./OverviewXrayPreview.vue?vue&type=style&index=0&id=6b951d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b951d2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
